export const mutedTrackColors = [
    '#FFEF00', // yellow
    '#A4A4A4', // grey
    '#000000', // black
    '#BAF200', // yellow-green
    '#FFC900', // yellow-orange
    '#7AD915', // lime
    '#784D3E', // brown
];

export const boldTrackColors = [
    '#F42410', // red
    '#E834EC', // pink

    '#A726BC', // purple
    '#5726C2', // dark purple
    '#2D3FC7', // dark blue

    '#0479FF', // blue
    '#00B2FF', // lighter blue
    '#00DAE1', // aqua

    '#00A478', // teal
    '#4ABD32', // green

    '#FF9D00', // orange
    '#FF6200', // dark orange

    '#5E7A8C', // blue grey
];

export default [...mutedTrackColors, ...boldTrackColors];
